import * as React from 'react';
import { IconBase } from 'react-icons';
function DeprecatedArrowUpIcon(props, svgRef) {
    return (
        <IconBase fill="none" viewBox="0 0 14 18" ref={svgRef} {...props}>
            <path
                d="M8 3.414l4.293 4.293a1 1 0 101.414-1.414l-6-6a1 1 0 00-1.414 0l-6 6a1 1 0 001.414 1.414L6 3.414v13.642c0 .521.448.944 1 .944s1-.423 1-.944V3.414z"
                fill="currentColor"
            />
        </IconBase>
    );
}
const ForwardRef = React.forwardRef(DeprecatedArrowUpIcon);
export default ForwardRef;
